import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  MIDDLE_WARE_BASE_URL_v1,
  INDIA_COMPLIANCE_DASHBOARD,
  INDIA_COMPLIANCE_DASHBOARD_ACCESS,
} from "../../../utils/CONSTANTS";

const initialState = {
  dashboardState: "idle",
  dashboardData: null as any,
  accessState: "idle", // idle | pending | fulfilled | failed
  hasAccess: false,
};

export const fetchIndiaComplianceDashboard = createAsyncThunk(
  "get/indiaComplianceDashboard",
  async (params: any) => {
    const qs = new URLSearchParams();
    ["page", "pageSize", "sortBy", "sortDir", "status", "search", "dateFrom", "dateTo", "program", "trainer", "classRosterId", "dueFrom", "dueTo"]
      .forEach((k) => { if (params?.[k]) qs.append(k, String(params[k])); });
    return await axios.getRequest(MIDDLE_WARE_BASE_URL_v1() + INDIA_COMPLIANCE_DASHBOARD() + "?" + qs.toString());
  }
);

// Allowlist access check — controls link visibility in My Resources + the route guard.
export const checkComplianceDashboardAccess = createAsyncThunk(
  "get/complianceDashboardAccess",
  async (params: { oracleId?: string; email?: string }) => {
    const qs = new URLSearchParams();
    if (params?.oracleId) qs.append("oracleId", params.oracleId);
    if (params?.email) qs.append("email", params.email);
    return await axios.getRequest(MIDDLE_WARE_BASE_URL_v1() + INDIA_COMPLIANCE_DASHBOARD_ACCESS() + "?" + qs.toString());
  }
);

const slice = createSlice({
  name: "indiaComplianceDashboard",
  initialState,
  reducers: {},
  extraReducers: (b) =>
    b.addCase(fetchIndiaComplianceDashboard.pending, (s) => { s.dashboardState = "pending"; })
     .addCase(fetchIndiaComplianceDashboard.fulfilled, (s, a: any) => {
        let res = a.payload?.data;
        if (typeof res === "string") { try { res = JSON.parse(res); } catch { /* keep raw */ } }
        s.dashboardState = "fulfilled"; s.dashboardData = res;
     })
     .addCase(fetchIndiaComplianceDashboard.rejected, (s) => { s.dashboardState = "failed"; })
     .addCase(checkComplianceDashboardAccess.pending, (s) => { s.accessState = "pending"; })
     .addCase(checkComplianceDashboardAccess.fulfilled, (s, a: any) => {
        // OperationResult<bool> -> a.payload.data === true/false
        s.accessState = "fulfilled";
        s.hasAccess = a.payload?.data === true || a.payload?.data === "true";
     })
     .addCase(checkComplianceDashboardAccess.rejected, (s) => { s.accessState = "failed"; s.hasAccess = false; }),
});

export const indiaComplianceDashboardDetails = (state: any) => state.indiaComplianceDashboard;
export default slice.reducer;
